import config from '../../../config/config';
// import getRequest from '../base/get';
import postRequest from '../base/post';
import postStream from '../base/postStream';

export default {
  // /**
  //  * getVersion
  //  */
  // getVersion: () => {
  //   return getRequest(`/version.txt`);
  // },
  /**
   * Self register API
   * @param {any} data - The data
   * @param {any} handleUploadProgress - The handleUploadProgress
   */
  selfRegistration: (data: any, handleUploadProgress: (progress: any) => void): Promise<any> => {
    return postStream(
      `${config.subscription.accountApiUrl}api/facility/v1/user-account/create`,
      data,
      true,
      handleUploadProgress,
    );
  },
  /**
   * Login API
   * @param {any} data - The data
   */
  login: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/login`, data);
  },
  /**
   * Verify Email API
   * @param {any} data - The data
   */
  verifyEmail: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/verify-email`, data);
  },
  /**
   * Verify Email API
   */
  resendEmailOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/resend-email-otp`);
  },
  /**
   * Verify Email API
   */
  resendMobileOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/resend-sms-otp`);
  },
  /**
   * Verify Mobile API
   * @param {any} data - The data
   */
  verifyMobile: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/verify-mobile`, data);
  },
  /**
   * Forgot password API
   * @param {any} data - The data
   */
  forgotPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/forgot-password`, data);
  },
  /**
   * Verify reset password OTP API
   * @param {any} data - The data
   */
  resetPasswordOTPVerify: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/forgot-password-otp-verify`, data);
  },
  /**
   * Reset password API
   * @param {any} data - The data
   */
  resetPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/reset-password`, data);
  },
  /**
   * Reset password token API
   * @param {any} data - The data
   */
  resetPasswordToken: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/reset-password-token`, data);
  },
  /**
   * Reset password API
   * @param {any} data - The data
   */
  initialResetPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/initial-reset-password`, data);
  },
  /**
   * Logout API
   * @param {any} data - The data
   */
  logout: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/logout`, data);
  },
};
